import React from "react";
import Lottie from "lottie-react";
import Loader from "../../assets/animations/Voice Visualization.json"; // Import JSON
const RecordingLoader: React.FC = () => {
  return <Lottie animationData={Loader} style={{ width:200, height:60 }} />;
};

export default RecordingLoader;